<template>
  <div class="course-task-manage-contain">
    <section class="task-filter clearfixx">
      <div class="filter-lf">
        <div class="filter-module clearfix">
          <p class="filter-module-name">{{ $t('courseTask.taskName') }}</p>
          <div class="filter-module-value">
            <el-input
              v-model="task.taskName"
              size="small"
              :placeholder="$t('contract.inputTips')"
              @keyup.enter.native="searchList()"
              clearable
            ></el-input>
          </div>
        </div>
        <div class="filter-module clearfix">
          <p class="filter-module-name">{{ $t('courseTask.taskStatus') }}</p>
          <div class="filter-module-value">
            <el-select v-model="task.taskStatus" clearable size="small">
              <el-option
                v-for="item in statusList"
                :key="'status'+item.code"
                :label="item.name"
                :value="item.code*1"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-module clearfix">
          <p class="filter-module-name">{{ $t('courseTask.creator2') }}</p>
          <div class="filter-module-value">
            <el-input
              v-model="task.creator"
              size="small"
              :placeholder="$t('contract.inputTips')"
              maxlength="50"
              @keyup.enter.native="searchList()"
              clearable
            ></el-input>
          </div>
        </div>
        <div class="filter-module clearfix">
          <p class="filter-module-name">{{ $t('courseTask.createTime') }}</p>
          <div class="filter-module-value">
            <el-date-picker
              v-model="task.createTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              size="small"
              :range-separator="$t('datePicker.range')"
              :start-placeholder="$t('datePicker.start')"
              :end-placeholder="$t('datePicker.end')">
            </el-date-picker>
          </div>
        </div>
        <div class="filter-module clearfix">
          <p class="filter-module-name">{{ $t('courseTask.importStatus') }}</p>
          <div class="filter-module-value">
            <el-select v-model="task.importStatus" clearable size="small">
              <el-option
                v-for="item in importStatusList"
                :key="'importStatus'+item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="filter-lr">
        <el-button class="M-search button-margin-b" type="primary" @click="searchList">
          {{ $t("query") }}
        </el-button>
        <el-button class="M-search el-back M-margin-l" type="info" @click="resetList">
          {{ $t("reset") }}
        </el-button>
      </div>
    </section>
    <section class="task-content">
      <article class="task-operate-buttons clearfix">
        <el-button type="primary" @click="goAdd(0)" v-if="$hasPermission('AUTHLOADTASK')">
          {{ $t("courseTask.addLoad") }}
        </el-button>
        <el-button type="primary" @click="goAdd(1)" v-if="$hasPermission('AUTHYEARNEWTASK')">
          {{ $t("courseTask.addNew") }}
        </el-button>
        <el-button type="primary" @click="downloadTask" :loading="downloading">
          {{ $t("export") }}
        </el-button>
      </article>
      <article class="task-list">
        <el-table v-loading="dataLoading" :data="dataList" border style="width: 100%"
        @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            header-align="center"
            align="center"
            width="50"
            fixed="left"
          ></el-table-column>
          <el-table-column
            type="index"
            :label="$t('pop.no')"
            :index="initIndex"
            width="70"
            header-align="center"
            align="center"
            fixed="left"
          ></el-table-column>
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            header-align="center"
            align="center"
            :width="item.width"
            :show-overflow-tooltip="true"
            :fixed="item.fixed"
            v-for="(item, index) in columnList"
            :key="'pop-list' + index"
          >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" align="center" width="160" :label="$t('handle')">
            <template slot-scope="scope">
              <span class="task-operate" @click="viewDetail(scope.row)">{{  $t("courseTask.viewTarget") }}</span>
              <span class="task-operate-line"></span>
              <el-dropdown trigger="click" placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editDetail(scope.row)" 
                  v-if="scope.row.status === 1 && scope.row.canCopy && scope.row.makeUpFlag === 0">{{ $t("update") }}
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="copyData(scope.row)"
                  v-if="scope.row.canCopy && scope.row.makeUpFlag === 0">{{ $t("courseTask.copy") }}</el-dropdown-item>
                  <el-dropdown-item @click.native="exectionTask(scope.row)"
                  v-if="scope.row.status === 1 && scope.row.canCopy">{{ $t("courseTask.execution") }}</el-dropdown-item>
                  <el-dropdown-item @click.native="goResult(scope.row)"
                  v-if="scope.row.status === 3">{{ $t("courseTask.resultDetail") }}</el-dropdown-item>
                  <el-dropdown-item @click.native="cancelResult(scope.row)"
                    v-if="scope.row.status === 2  && scope.row.canCopy">
                    {{ $t("courseTask.cancelRun") }}</el-dropdown-item>
                  <el-dropdown-item @click.native="cancelQueue(scope.row.id)"
                    v-if="scope.row.status === 7  && scope.row.canCopy">
                    {{ $t("courseTask.cancelQueue") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </article>
      <article class="task-footer">
        <el-pagination
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
        >
        </el-pagination>
      </article>
    </section>
    <!-- 错误弹出 -->
    <errorModal v-if="errorVisible"
      @closeModal="closeError"
      :errorData="errorData"
      :taskType="taskType"
      :taskName="taskName"
      :isErrorContinue="isErrorContinue">
    </errorModal>
  </div>
</template>
<script>
import errorModal from './courseCheckModal.vue';
import dayjs from 'dayjs';
export default {
  components: {
    errorModal
  },
  data() {
    return {
      importStatusList: this.enums['courseTaskImport'],
      statusList: this.enums['courseTaskStatus'],
      task: {
        taskName: '',
        taskStatus: '',
        creator: '',
        createTime: [],
        importStatus: ''
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dataLoading: false,
      columnList: [
        { label: this.$t('courseTask.taskName'), prop: 'taskName' },
        { label: this.$t('courseTask.taskStatus'), prop: 'statusName'},
        { label: this.$t('courseTask.taskType'), prop: 'taskTypeName'},
        { label: this.$t('courseTask.creator'), prop: 'createUserCode'},
        { label: this.$t('courseTask.createTime'), prop: 'createTime', width: 160 },
        { label: this.$t('courseTask.updateTime'), prop: 'updateTime', width: 160 },
        { label: this.$t('courseTask.successRate'), prop: 'scheduleRate'},
        { label: this.$t('courseTask.taskExecutionTime'), prop: 'taskExecutionTimeDesc', width: 146 },
        { label: this.$t('courseTask.successTargetNume'), prop: 'scheduleCourseNums', width: 140 },
        { label: this.$t('courseTask.isSchedule'), prop: 'importStatusName', width: 140 }
      ],
      dataList: [],
      multipleSelection: [],
      errorVisible: false,
      errorData: null,
      isErrorContinue: false,
      taskType: 0,
      execuId: '',
      taskName: '',
      downloading: false
    };
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    downloadTask () {
      const arr = this.multipleSelection.map((item) => {
        return item.id;
      });
      let params = {
        ids: arr
      };
      if (arr.length === 0) {
        params = {
          taskName: this.task.taskName,
          createTime1: this.task.createTime && this.task.createTime.length === 2 ? 
            this.task.createTime[0] + ' 00:00:00' : '',
          createTime2: this.task.createTime && this.task.createTime.length === 2 ?
          this.task.createTime[1] + ' 23:59:59' : '',
          status: this.task.taskStatus,
          importStatus: this.task.importStatus,
          createUserCode: this.task.creator,
        };
      }
      this.downloading = true;
      this.$request.downloadByPost7(
        '/classschedule/scheduleTask/exportScheduleTask',
        `${this.$t('courseTask.downTaskInfo') }_${  dayjs().format('YYYY-MM-DD HH:mm:ss')  }.xls`,
        params, null, 'xls'
      );
      this.$message({
        message: this.$t('courseSchedule.downloading'),
        type: 'success',
      });
      setTimeout(() => {
        this.downloading = false;
      }, 1500);
    },
    goAdd (val) {
      if (val === 0) {
        this.$router.push({
          name: 'rm-courseTask-courseTaskLoad'
        });
        this.$eventHub.$emit('courseTaskLoad', '');
      } else {
        this.$router.push({
          name: 'rm-courseTask-courseTaskNew'
        });
        this.$eventHub.$emit('courseTaskNew', '');
      }
    },
    initIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    pageSizeChangeHandle(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getDataList();
    },
    pageCurrentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    searchList () {
      this.pageSize = 10;
      this.pageNum = 1;
      this.taskName = '';
      this.getDataList();
    },
    resetList () {
      Object.keys(this.task).forEach((item) => {
        this.task[item] = '';
        if (item === 'createTime') {
          this.task[item] = [];
        }
      });
      this.searchList();
    },
    copyData (val) {
      if (val.taskType === 1) {
        this.$router.push({
          name: 'rm-courseTask-courseTaskNew',
          query: {
            taskId: val.id,
            isCopy: true
          }
        });
        this.$eventHub.$emit('courseTaskNew', { taskId: val.id, isCopy: true});
      } else {
        this.$router.push({
          name: 'rm-courseTask-courseTaskLoad',
          query: {
            taskId: val.id,
            isCopy: true
          }
        });
        this.$eventHub.$emit('courseTaskLoad', { taskId: val.id, isCopy: true});
      }
    },
    viewDetail (val) {
      if (val.taskType === 1) {
        this.$router.push({
          name: 'rm-courseTask-courseTaskNewDetail',
          query: {
            taskId: val.id,
            isEdit: false
          }
        });
        this.$eventHub.$emit('courseTaskNewDetail', { taskId: val.id, isEdit: false});
      } else {
        this.$router.push({
          name: 'rm-courseTask-courseTaskLoadDetail',
          query: {
            taskId: val.id,
            isEdit: false
          }
        });
        this.$eventHub.$emit('courseTaskLoadDetail', { taskId: val.id, isEdit: false});
      }
    },
    editDetail (val) {
      if (val.taskType === 1) {
        this.$router.push({
          name: 'rm-courseTask-courseTaskNew',
          query: {
            taskId: val.id,
            isEdit: true
          }
        });
        this.$eventHub.$emit('courseTaskNew', { taskId: val.id, isEdit: true});
      } else {
        this.$router.push({
          name: 'rm-courseTask-courseTaskLoad',
          query: {
            taskId: val.id,
            isEdit: true
          }
        });
        this.$eventHub.$emit('courseTaskLoad', { taskId: val.id, isEdit: true});
      }
    },
    goResult (val) {
      this.$router.push({
        name: 'rm-courseTask-courseTaskResult',
        query: {
          taskId: val.id
        }
      });
      this.$eventHub.$emit('courseTaskNew', { taskId: val.id });
    },
    getDataList () {
      const params = {
        taskName: this.task.taskName,
        createTime1: this.task.createTime && this.task.createTime.length === 2 ?
          this.task.createTime[0] + ' 00:00:00' : '',
        createTime2: this.task.createTime && this.task.createTime.length === 2 ?
          this.task.createTime[1] + ' 23:59:59' : '',
        status: this.task.taskStatus,
        importStatus: this.task.importStatus,
        createUserCode: this.task.creator,
        page: this.pageNum,
        limit: this.pageSize
      };
      this.dataLoading = true;
      const userInfo = JSON.parse(sessionStorage.getItem('v1user_data'));
      this.$request.get('/classschedule/scheduleTask/page', params).then((res) => {
        if (res) {
          const data = res.records || [];
          this.dataList = data.map((item) => {
            return { ...item, 
              scheduleCourseNums: item.scheduleCourseNum ? 
                `${item.scheduleCourseNum  }/${  item.scheduleCourseNum + item.unScheduleCourseNum}` : '/',
              canCopy: item.taskType === 0 ? this.$hasPermission('AUTHLOADTASK') : 
                item.createUser.toString() == userInfo.userId.toString() || userInfo.userCode === 'admin'
                || this.$hasPermission('AUTHLOADTASK') };
          });
          this.total = res.total;
        }
        this.dataLoading = false;
      }).catch(() => {
        this.dataLoading = false;
      });
    },
    exectionTask (row) {
      this.taskType = row.taskType;
      this.dataLoading = true;
      this.execuId = '';
      this.taskName = row.taskName;
       this.$request.post(`/classschedule/coursePkgCheck/checkTaskWhenExecute?taskId=${row.id}`).then((res) => {
        if (res) {
          this.isErrorContinue = false;
          if (res.status === -1 ) {
            this.errorData = res.data;
            this.errorVisible = true;
            this.dataLoading = false;
          } else if (res.status === -2) { 
            this.$message({
              message: res.message,
              type: 'warning',
            });
            this.dataLoading = false;
          }  else if (res.status === -3) { 
            this.errorData = res.data;
            this.errorVisible = true;
            this.isErrorContinue = true;
            this.execuId = row.id;
            this.dataLoading = false;
          } else {
            this.errorVisible = false;
            this.execuId = row.id;
            this.executionTaskFinal(row.id);
          }
        }
      }).catch(() => {
        this.dataLoading = false;
      });
    },
    executionTaskFinal (id) {
      this.dataLoading = true;
      this.$request.post(`/classschedule/scheduleTask/executeTask?scheduleTaskId=${id}`)
      .then((_res, _total, code, data) => {
        if (code === 10000006) {
          this.$confirm(data.msg, this.$t('prompt.title'), {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            this.sureQueue(id);
          }).catch(() => {
            this.dataLoading = false;
            this.searchList();
          });
        } else {
          this.$message({
            message: this.$t('courseTask.executionSuccess'),
            type: 'success',
          });
          this.dataLoading = false;
          this.searchList();
        }
      }).catch(() => {
        this.$message({
          message: this.$t('courseTask.executionFailed'),
          type: 'warning',
        });
        this.dataLoading = false;
      });
    },
    sureQueue (id) {
      this.$request.post(`/classschedule/scheduleTask/confirmInQueue?scheduleTaskId=${id}`).then(() => {
        this.dataLoading = false;
        this.searchList();
      }).catch(() => {
        this.dataLoading = false;
      });
    },
    cancelQueue (id) {
      this.$request.post(`/classschedule/scheduleTask/cancelInQueue?scheduleTaskId=${id}`).then(() => {
        this.searchList();
      });
    },
    cancelResult (val) {
       this.$confirm(this.$t('prompt.info', { 'handle': this.$t('courseTask.cancelRun') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.dataLoading = false;
        this.$request.post(`/classschedule/scheduleTask/cancelTask?scheduleTaskId=${val.id}`).then(() => {
          this.$message({
            message: this.$t('courseTask.cancelSuccess'),
            type: 'success',
          });
          this.dataLoading = false;
          this.searchList();
        }).catch(() => {
          this.dataLoading = false;
        });
      });
    },
    closeError (val) {
      this.errorVisible = false;
      this.errorData = null;
      if (val === 1) {
        this.executionTaskFinal(this.execuId);
      } else {
        this.dataLoading = false;
      }
    },
  },
  mounted() {
    this.searchList()
    this.$eventHub.$on('courseTaskManage', (data) => {
      if (data) {
        Object.keys(this.task).forEach((item) => {
          this.task[item] = item === 'createTime' ? [] : '';
        });
        this.pageSize = 10;
        this.pageNum = 1;
        this.searchList();
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.course-task-manage-contain {
  min-height: calc(100% - 120px);
  .task-filter {
    display: flex;
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
    .filter-lf {
      flex: 8;
      .filter-module {
        width: 33.33%;
        padding-right: 5%;
        float: left;
        margin-bottom: 12px;
        .filter-module-name {
          line-height: 26px;
          margin: 0;
        }
        .filter-module-value {
          height: 32px;
        }
      }
    }
    .filter-lr {
      flex: 1;
      vertical-align: middle;
      padding-left: 20px;
      .button-margin-b {
        margin-bottom: 7px;
      }
    }
  }
  .task-content {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 12px;
    .task-list {
      margin: 20px 0;
    }
    .task-operate {
      cursor: pointer;
      color: #409eff;
      &:hover {
        opacity: .8;
      }
    }
    .task-operate-line {
      display: inline-block;
      width: 1px;
      height: 20px;
      margin: 0 8px;
      vertical-align: middle;
      position: relative;
      background-color: #DCDFE6;
    }
  }
}
</style>
<style lang="scss">
.course-task-manage-contain {
  .filter-module-value {
    .el-date-editor {
      width:  100% !important;
    }
  }
  .el-range-separator {
    line-height: 32px !important;
  }
}
</style>